import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { Activity } from "@/models/activity.model"
import { type IActivity } from "@/interfaces/api/activity.interface"
import { ActivityRepository } from "@/repositories/activity-repository"
import { useActivityStore } from "@/store/activity.store"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { type IStoreFunctionsConfig } from "@/store/base-functions/base-store-functions"

export class ActivityController extends GenericModelController<
  Activity,
  IActivity,
  ActivityRepository
> {
  constructor(storeFunctionsConfig?: IStoreFunctionsConfig<Activity>) {
    let enableSynchronization = false
    if (!storeFunctionsConfig) {
      const activityStore = useActivityStore()
      const { pushToRelatedWorkPeriod, removeFromRelatedWorkPeriod } = activityStore
      storeFunctionsConfig = {
        managed: true,
        onCreate: pushToRelatedWorkPeriod,
        onDelete: removeFromRelatedWorkPeriod
      }
      enableSynchronization = true
    }

    super(Activity, storeFunctionsConfig, new ActivityRepository())

    if (enableSynchronization) {
      this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
        Activity,
        null,
        storeFunctionsConfig.onCreate,
        storeFunctionsConfig.onDelete,
        false // For testing purposes (so we can add items in the app and see them coming in at planning)
      )
    }
  }
}
